import styles from './paymentSummary.module.scss';
import { TXT_PRICE_VALID_FOR } from '../constants';

interface PriceSummaryProps {
    title: string;
    originalPrice: number;
    discountCode: string;
    discount: number;
    showMembershipPeriodText: boolean;
}

function PriceSummary({ title, originalPrice, discountCode, discount, showMembershipPeriodText }: PriceSummaryProps) {
    return (
        <div className={styles.priceSummary}>
            <div className={styles.gridrow}>
                <div className={styles.membershipTitle}>{title}</div>
                <div className={styles.originalPrice}>{originalPrice} kr</div>
            </div>

            {showMembershipPeriodText && <div className={styles.yearlyText}>{TXT_PRICE_VALID_FOR}</div>}

            {discountCode && (
                <>
                    <div className={[styles.discountRow, styles.gridrow].join(' ')}>
                        <div className={styles.discountCode}>Rabatt {discountCode}</div>
                        <div className={styles.discountAmount}>- {discount} kr</div>
                    </div>
                    <div className={[styles.totalRow, styles.gridrow].join(' ')}>
                        <div className={styles.total}>{'Totalt'}</div>
                        <div className={styles.totalPrice}>{originalPrice - discount} kr</div>
                    </div>
                </>
            )}
        </div>
    );
}

export default PriceSummary;
